import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import StreamIcon from '@mui/icons-material/Stream';
import TabIcon from '@mui/icons-material/Tab';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import NoteAltIcon from '@mui/icons-material/NoteAlt';

const Services = () => {
    return (
        <Box sx={{ p: { xs: 2, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: {xs: '18px',sm:'21px'}, color: 'primary.main' }}>Service</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: {xs: '25px',sm:'47px'} }}>Never compromise <br /> with quality</Typography>
            </Box>

            <Box sx={{ pt: 10 }}>
                <Grid container spacing={4}>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <GridViewIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>Wireframing</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <StreamIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>Prototype</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <TabIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>UI Design</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <PersonAddIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>Personal Creation</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <WorkHistoryIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>Case Study</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={6} sx={{ textAlign: 'center', p: 5, borderRadius: '10px' }}>
                            <Box sx={{ borderRadius: '100%', backgroundColor: 'secondary.main', width: '110px', height: '110px', display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 'auto' }}>
                                <NoteAltIcon sx={{ fontSize: '60px', color: '#fff' }} />
                            </Box>
                            <Typography variant='h4' sx={{ fontSize: '24px', fontWeight: 700, my: 3 }}>Experience Design</Typography>
                            <Typography variant='h6' sx={{ fontSize: '18px', fontWeight: 300, color: 'muted.main' }}>Web development is the building and maintenance of websites. it’s the work that...</Typography>
                        </Paper>
                    </Grid>



                </Grid>
            </Box>


        </Box>
    );
};

export default Services;